class ModalService {

    constructor($timeout) {
        'ngInject';
        
        this.$timeout = $timeout;
        this.modals = [];
    }

    add(title = null, content, callback = null, allowClose = true, id = null) {
        const modal = {
            title,
            content,
            isOpen: false,
            allowClose,
            callback,
            id
        };

        const open = () => {
            modal.isOpen = true;
        }

        modal.open = open;

        const close = (returnData = null) => {
            modal.isOpen = false;

            if (! modal.callback || typeof modal.callback != 'function') return;

            modal.callback(returnData);
        }

        modal.close = close;
        
        this.modals.push(modal);
        
        return modal;
    }
}

export default ModalService;